var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"referrals"}},[_c('card',{attrs:{"icon":"filter","headline":_vm.$t('visitors.topReferrals.headline'),"description":_vm.$t('visitors.topReferrals.description')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }